export * from './extinguisher.interface';
export * from './object-type.interface';
export * from './placement.interface';
export * from './position.interface';
export * from './review.interface';
export * from './review-template.interface';
export * from './user.interface';
export * from './global-search.interface';
export * from './repair-set.interface';
export * from './title.interface';



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/admin/shared/models/index.ts